import React from 'react'
import ReactModal from 'react-modal'
import { ModalGlobalStyle } from './components/Styled'
import { ReactComponent as CloseSvgIcon } from 'resources/svg/icons/close.svg'
import { ReactComponent as CloseThinSvgIcon } from 'resources/svg/icons/close-thin.svg'
import { CSS_CLASS } from './constants'

interface Props {
  children: React.ReactNode
  handleCloseModal?: () => void
  onRequestClose?: () => void
  shouldCloseOnEsc?: boolean
  shouldCloseOnOverlayClick?: boolean
  isOpen: boolean
  modalTitle?: string
  footer?: React.ReactElement
  type: 'normal' | 'productOptions' | 'miniCart' | 'reviews' | 'large'
  backgroundImage?: string
  isCloseThin?: boolean
}

export const Modal: React.FC<Props> = (props) => {
  const {
    children,
    handleCloseModal,
    onRequestClose,
    shouldCloseOnEsc,
    shouldCloseOnOverlayClick,
    isOpen,
    modalTitle,
    footer,
    type,
    backgroundImage,
    isCloseThin
  } = props

  const handleAfterOpen = () => {
    document.documentElement.classList.add(CSS_CLASS.REMOVE_SCROLL)
  }

  const handleAfterClose = () => {
    document.documentElement.classList.remove(CSS_CLASS.REMOVE_SCROLL)
  }

  const className = `${CSS_CLASS.MODAL} ${type}`
  const overlay = type === 'miniCart' ? CSS_CLASS.OVERLAY_CLEAR : CSS_CLASS.OVERLAY

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose ?? handleCloseModal}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      ariaHideApp={false}
      className={className}
      overlayClassName={overlay}
      onAfterOpen={handleAfterOpen}
      onAfterClose={handleAfterClose}
    >
      <div
        className={CSS_CLASS.CONTENT_WRAP}
        style={{
          backgroundImage: `url(${backgroundImage})`
        }}
      >
        <div className={CSS_CLASS.HEADER}>
          {modalTitle && (
            <h3>{modalTitle}</h3>
          )}
          {handleCloseModal && (
            <button
              onClick={handleCloseModal}
              className={CSS_CLASS.CLOSE}
            >
              {isCloseThin ? (
                <CloseThinSvgIcon />
              ) : (
                <CloseSvgIcon />
              )}
            </button>
          )}
        </div>
        <div className={CSS_CLASS.CONTENT}>
          {children}
        </div>
        <div className={CSS_CLASS.FOOTER}>
          {footer}
        </div>
      </div>
    </ReactModal>
  )
}

export {
  ModalGlobalStyle
}
